import M from '@materializecss/materialize';
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

const EditInvoicePoNumberModal = ({
  isOpen,
  setIsOpen,
  setCustomerPoNumber,
  invoice,
  updateCustomerPoNumber,
}) => {
  const modal = useRef(null);
  const [poNumber, setPoNumber] = useState('');

  useLayoutEffect(() => {
    M.Modal.init(modal.current, {
      onCloseEnd: () => setIsOpen(false),
    });
    return () => {
      M.Modal.getInstance(modal.current)?.destroy();
    };
  }, []);

  const getModal = () =>
    modal.current ? M.Modal.getInstance(modal.current) : null;

  const openModal = useCallback(() => {
    setPoNumber(invoice.customerPoNumber);
    getModal()?.open();
    setTimeout(() => {
      M.updateTextFields();
    }, 150);
  }, [invoice, setPoNumber, getModal]);

  const closeModal = () => getModal()?.close();

  useEffect(() => {
    if (modal.current) {
      if (isOpen) return openModal();
      closeModal();
    }
  }, [isOpen]);

  const save = e => {
    e?.preventDefault();
    setCustomerPoNumber(poNumber);
    updateCustomerPoNumber(poNumber);
    closeModal();
  };

  return (
    <div ref={modal} className="modal">
      <div className="modal-content">
        <div className="row">
          <h5>Edit Customer PO Number</h5>
        </div>
        <div className="row">
          <div className="input-field col s12 m4">
            <input
              id="customerPoNumber"
              type="text"
              value={poNumber}
              onChange={e => setPoNumber(e.target.value)}
            />
            <label htmlFor="customerPoNumber">Customer PO Number</label>
          </div>
        </div>
        <div className="row">
          <div className="col s12 m4 offset-m4">
            <a
              href="/"
              onClick={save}
              className="btn-small blue white-text waves-effect waves-light col s12"
            >
              Save
            </a>
          </div>
          <div className="col s12 m4">
            <a
              href="/"
              onClick={e => {
                e.preventDefault();
                closeModal();
              }}
              className="btn-small white blue-text waves-effect waves-light col s12"
            >
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditInvoicePoNumberModal;
